import * as actionTypes from "./InvoiceRequestType";

const INITIAL_STATE = {
    invReqList: [],
    invReqNoList: [],
    filterCustomerList: [],
    items: [],
    itemList: [],
    customersList: [],
    taxList: [],
    warehouseList: [],
    costcenterList: [],
    paytermsList: [],
    supplyList: [],
    salesempList: [],
    invoiceRequest: null,
    customerAddress: [],
    customerAddressList: [],
    prjList: [],
    seriesList: [],
    hsnList: [],
    salesOrder: null,
    salesOrderList: [],
    itemInfo: null,
    customerInfo: [],
    duplicateDoc: null,
    defaultCurrency: null,
    basicFilterData: []
};

const InvoiceRequestReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETREQNOLIST:
            return {
                ...state,
                invReqNoList: action.payload.list,
            };
        case actionTypes.SETFILTERCUSTOMERLIST:
            return {
                ...state,
                filterCustomerList: action.payload.list,
            };
        case actionTypes.SETINVREQLIST:
            return {
                ...state,
                invReqList: action.payload.list,
            };
        case actionTypes.SETITEMS:
            return {
                ...state,
                items: action.payload.list,
            };
        case actionTypes.SETCUSTOMERLIST:
            return {
                ...state,
                customersList: action.payload.list,
            };
        case actionTypes.SETPAYTERMSLIST:
            return {
                ...state,
                paytermsList: action.payload.list,
            };
        case actionTypes.SETSUPPLYLIST:
            return {
                ...state,
                supplyList: action.payload.list,
            };
        case actionTypes.SETSALESEMPLIST:
            return {
                ...state,
                salesempList: action.payload.list,
            };
        case actionTypes.SETCUSTOMERADDRESS:
            return {
                ...state,
                customerAddress: action.payload.list,
            };
        case actionTypes.SETCUSTOMERADDRESSLIST:
            return {
                ...state,
                customerAddressList: action.payload.list,
            };
        case actionTypes.SETWHSELIST:
            return {
                ...state,
                warehouseList: action.payload.list,
            };
        case actionTypes.SETPRJLIST:
            return {
                ...state,
                prjList: action.payload.list,
            };
        case actionTypes.SETTAXLIST:
            return {
                ...state,
                taxList: action.payload.list,
            };
        case actionTypes.SETCOSTCENTERLIST:
            return {
                ...state,
                costcenterList: action.payload.list,
            };
        case actionTypes.SETITEMLIST:
            return {
                ...state,
                itemList: action.payload,
            };
        case actionTypes.SETSERIESLIST:
            return {
                ...state,
                seriesList: action.payload.list,
            };
        case actionTypes.SETHSNLIST:
            return {
                ...state,
                hsnList: action.payload.list,
            };
        case actionTypes.SETINVREQ:
            return {
                ...state,
                invoiceRequest: action.payload.data,
            };
        case actionTypes.CLEARDOC:
            return {
                ...state,
                invoiceRequest: null,
                itemList: [],
                customerAddress: [],
                customerAddressList: [],
                salesOrder: null,
                salesOrderList: [],
                itemInfo: null,
                customerInfo: []
            };
        case actionTypes.SETSALESORDER:
            return {
                ...state,
                salesOrder: action.payload.data,
            };
        case actionTypes.SETCOPYFROMORDERLIST:
            return {
                ...state,
                salesOrderList: action.payload.list,
            };
        case actionTypes.SETATTACHMENTLIST:
            return {
                ...state,
                attachmentList: action.payload.list,
            };
        case actionTypes.SETADVANCEFILTERLIST:
            return {
                ...state,
                advanceFilterList: action.payload.list
            };
        case actionTypes.SETITEMINFO:
            return {
                ...state,
                itemInfo: action.payload.data
            };
        case actionTypes.SETCUSTOMERINFO:
            return {
                ...state,
                customerInfo: action.payload.data
            };
        case actionTypes.SETDUPLICATEDOC:
            return {
                ...state,
                duplicateDoc: action.payload.data
            };
        case actionTypes.SETDEFAULTCURRENCY:
            return {
                ...state,
                defaultCurrency: action.payload.data
            };
        case actionTypes.SETINVOICEREQUESTBASICFILTERDATA:
            return {
                ...state,
                basicFilterData: { ...action.payload }
            };
        default:
            return state;
    }
}

export default InvoiceRequestReducer;